import { FC } from "react";

import { Button } from "@/components/_ui/button";
import { UnitSelectDropdown } from "@/domain/unit/components/unit-select-dropdown";
import { UnitView } from "@/domain/unit/components/unit-view";
import { UnitWithKeyResults } from "@/domain/unit/models/unit-model";
import { cn } from "@/lib/cn";

interface DatatableUnitCellpProps {
  workspaceId: string;
  unit: Omit<UnitWithKeyResults, "keyResults"> | null | undefined;
  onSelect: (unitId: string | null) => void;
  className?: string;
  editable: boolean;
}

export const DatatableUnitCell: FC<DatatableUnitCellpProps> = ({
  workspaceId,
  unit,
  className,
  editable,
  onSelect,
}) => {
  if (!editable) {
    return (
      <UnitView
        unit={unit}
        className={cn(["h-3 px-2", unit ? "" : "text-muted-foreground"])}
        data-testid="datable-unit-cell"
      />
    );
  }

  return (
    <UnitSelectDropdown
      workspaceId={workspaceId}
      onSelect={onSelect}
      defaultValue={unit?.id ?? null}
      asChild
      data-testid="datable-unit-cell"
    >
      <Button
        variant="ghost"
        size="icon"
        className={cn([
          "w-full justify-start overflow-x-hidden px-2 text-xs font-normal ring-offset-background focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
          className,
        ])}
      >
        <UnitView unit={unit} className={cn(["h-3 ", unit ? "" : "text-muted-foreground"])} />
      </Button>
    </UnitSelectDropdown>
  );
};
